import React from 'react';
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react';
import { Button, Group, Text } from '@mantine/core';
import styles from './ChartHeader.module.css';

interface ChartHeaderProps {
  ranges: string[];
  selectedRange: string;
  onRangeChange: (range: string) => void;
  currentLabel?: string;
  onPrevious?: () => void;
  onNext?: () => void;
  disablePrevious?: boolean;
  disableNext?: boolean;
  disabledRanges?: string[];
}

const ChartHeader: React.FC<ChartHeaderProps> = ({
  ranges,
  selectedRange,
  onRangeChange,
  currentLabel,
  onPrevious,
  onNext,
  disablePrevious = false,
  disableNext = false,
  disabledRanges = [],
}) => (
  <div className={styles.container}>
    <Group className={styles.group}>
      {ranges.map((range) => (
        <Button
          key={range}
          size="xs"
          variant={selectedRange === range ? 'filled' : 'outline'}
          onClick={() => !disabledRanges.includes(range) && onRangeChange(range)}
          disabled={disabledRanges.includes(range)}
          style={{
            opacity: disabledRanges.includes(range) ? 0.5 : 1,
            cursor: disabledRanges.includes(range) ? 'not-allowed' : 'pointer',
          }}
        >
          {range}
        </Button>
      ))}
    </Group>

    <Group className={styles.group}>
      {onPrevious && (
        <Button
          onClick={onPrevious}
          size="xs"
          variant="outline"
          disabled={disablePrevious}
          style={{ cursor: disablePrevious ? 'not-allowed' : 'pointer' }}
        >
          <IconArrowLeft size={10} />
        </Button>
      )}
      <Text size="sm">{currentLabel}</Text>
      {onNext && (
        <Button
          onClick={onNext}
          size="xs"
          variant="outline"
          disabled={disableNext}
          style={{ cursor: disableNext ? 'not-allowed' : 'pointer' }}
        >
          <IconArrowRight size={10} />
        </Button>
      )}
    </Group>
  </div>
);

export default ChartHeader;
